import type { CalendarEvent } from "@/types/events.ts";
import { atom } from "jotai";

/**
 * The event a delete has been requested for, or null when none is pending.
 *
 * An atom because the two ends are far apart, and deliberately so (BIG-8266).
 * The confirmation used to be state inside `EventDetailPanel`, which made it a
 * child of the very surface it was asking about: choosing "Delete event" closes
 * that surface, and the dialog went with it — the user saw a confirmation
 * appear and vanish, with nothing in the DOM afterwards to explain it.
 *
 * Hoisting it one level would not have fixed it either. Every surface that
 * shows an event is itself conditionally mounted — the click popover by
 * `useCanvasCalendarSurface`, the canvas card by `CanvasSourceModal` — so each
 * of them can disappear for the same reason. The only safe place is one that
 * outlives all of them, which is why {@link EventDeleteDialogs} is mounted
 * beside `HeaderUtilities` in `ViewWrapper` and reads this.
 */
export const eventPendingDeleteAtom = atom<CalendarEvent | null>(null);
